import I96ScrollChecker from "../i96-scroll_checker.class.js";

class I96MobileMaxText {

    constructor(config = {}) {

        this.debug = false;

        const settings_maxtext_default = {
            element_selector: '.-i96-mobile-max-text',
            elements: []
        }

        this.settings = {
            ...settings_maxtext_default,
            ...config
        }

        if (this.debug) console.log('I96MobileMaxText: constructor(' + config + ')');

        this.init();

    }

    init() {
        if (this.debug) console.log('I96MobileMaxText: init()');

        this.settings.elements = document.querySelectorAll(this.settings.element_selector)

        this.settings.elements.forEach((ele, index) => {
            if (this.debug) console.log('I96MobileMaxText: init() > ELE: ', index, ele);
            const mehr_lesen_button = ele.querySelector('.button-mehr-lesen');
            if (!this.hazMehrLesenButton(ele)) {
                this.addMehrLesenButton(ele, index);
            }

        });

    }

    hazMehrLesenButton(ele) {
        return ele.querySelector('.button-mehr-lesen') && ele.querySelector('.button-mehr-lesen').length > 0
    }

    getMehrLesenButton(index) {
        return document.querySelector('.mehr-lesen-button[data-index="' + index + '"]');
    }
    getMehrLesenTarget(index) {
        return document.querySelector(this.settings.element_selector + '[data-index="' + index + '"]');
    }

    addMehrLesenButton(ele, index) {
        let div = document.createElement("div");
        // let p = document.createElement("p");
        div.innerHTML = "Mehr Lesen";
        div.classList.add('mehr-lesen-button', 'button', '_text-headline');
        div.setAttribute('data-index', index);
        ele.setAttribute('data-index', index);
        ele.after(div);
        this.addMehrLesenButtonEventListener( index );
    }

    addMehrLesenButtonEventListener( index ) {
        const button = this.getMehrLesenButton( index );
        if ( button ) {
            button.addEventListener('click', e => {
                const index = e.currentTarget.getAttribute('data-index');
                const target = this.getMehrLesenTarget( index );
                target.classList.add('_open');
                e.currentTarget.classList.add('hidden');
                console.log(index, 'clicked', target);
            });
        }
    }


    /**
     * Adds event listeners to the 'Mehr Lesen' buttons
     */
    addEventListeners() {

    }

    _pseudoElementClick() {
        // as per https://medium.com/@r.harvey/how-to-detect-whether-a-pseudo-element-was-clicked-in-js-862deca19cca

        this.settings.elements = document.querySelectorAll( this.settings.element_selector )

        this.settings.elements.forEach( ele => {
            ele.addEventListener("click", e =>{
                // First we get the pseudo-elements style
                const target = e.currentTarget || e.target
                const after = getComputedStyle(target, ":after")
                if (after) {
                    // Then we parse out the dimensions
                    const atop = Number(after.getPropertyValue("top").slice(0, -2))
                    const aheight = Number(after.getPropertyValue("height").slice(0, -2))
                    const aleft = Number(after.getPropertyValue("left").slice(0, -2))
                    const awidth = Number(after.getPropertyValue("width").slice(0, -2))
                    // And get the mouse position
                    const ex = e.layerX
                    const ey = e.layerY
                    // Finally we do a bounds check (Is the mouse inside of the after element)
                    if (ex > aleft && ex < aleft+awidth && ey > atop && ey < atop+aheight) {
                        console.log("Button clicked")
                        target.style.display = "none"
                    }
                }
            })
        })
    }

}


export default I96MobileMaxText